// Supermove
import {OrganizationModel} from '@supermove/models';

export const sortBranches = (a: OrganizationModel, b: OrganizationModel) => {
  if (a.kind === 'MAIN' && b.kind !== 'MAIN') {
    return -1;
  }
  if (a.kind !== 'MAIN' && b.kind === 'MAIN') {
    return 1;
  }
  if (a.kind === 'BRANCH' && b.kind !== 'BRANCH') {
    return -1;
  }
  if (a.kind !== 'BRANCH' && b.kind === 'BRANCH') {
    return 1;
  }
  if (a.kind === 'CONTRACTOR' && b.kind !== 'CONTRACTOR') {
    return -1;
  }
  if (a.kind !== 'CONTRACTOR' && b.kind === 'CONTRACTOR') {
    return 1;
  }
  return a.name.localeCompare(b.name);
};
